import React, { useState, useEffect } from 'react';
import Web3 from 'web3';

const WalletConnection = () => {
  const [account, setAccount] = useState('');
  const [walletConnected, setWalletConnected] = useState(false);

  useEffect(() => {
    const connectWallet = async () => {
      if (window.ethereum) {
        try {
          // Request account access
          await window.ethereum.request({ method: 'eth_requestAccounts' });

          // Initialize web3
          const web3Instance = new Web3(window.ethereum);

          // Get selected account
          const accounts = await web3Instance.eth.getAccounts();
          setAccount(accounts[0]);
          setWalletConnected(true);
        } catch (error) {
          console.error('Error connecting to wallet:', error);
        }
      } else {
        console.error('No wallet detected');
      }
    };

    connectWallet();
  }, []);

  const handleConnectWallet = async () => {
    try {
      // Request account access
      await window.ethereum.request({ method: 'eth_requestAccounts' });

      // Initialize web3
      const web3Instance = new Web3(window.ethereum);

      // Get selected account
      const accounts = await web3Instance.eth.getAccounts();
      setAccount(accounts[0]);
      setWalletConnected(true);
    } catch (error) {
      console.error('Error connecting to wallet:', error);
    }
  };

  return (
    <div>
      {walletConnected ? (
        <p>Connected to {account}</p>
      ) : (
        <button onClick={handleConnectWallet}>Connect Wallet</button>
      )}
    </div>
  );
};

export default WalletConnection;
